"use strict";

var cookieInformationElement = document.getElementById('cookieInformation');
var closeCookieInformationElement = document.getElementById('closeCookieInformation');
var cookiesAccepted = window.localStorage.getItem('cookiesAccepted') === 'true';

if (!cookiesAccepted) {
  window.requestAnimationFrame(function () {
    cookieInformationElement.classList.add('show');
    cookieInformationElement.querySelectorAll('div, button').forEach(function (child) {
      child.style.opacity = 1;
    });
  });
}

closeCookieInformationElement.onclick = function () {
  window.localStorage.setItem('cookiesAccepted', 'true');
  cookieInformationElement.classList.remove('show');
};